import React from 'react'
import { BCardBody, BForm, BIcon, BTitle } from '@prague-digi/ui-components'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import { API_ERROR } from '../../constants/modals'
import { ApiErrorInfo } from '../../api/api'
import { InfoCheckbox, Notification, PageControlButtons } from '../../components'
import { IntlInterface, intl, wizard, WizardInterface } from '../../hoc'
import { modalDialogActions, requirementActions } from '../../redux'
import { ReduxState } from '../../types'
import { Requirement } from '../../redux/reducers/requirement/model'
import { Routes } from '../../constants'
import agreements from '../../assets/clientCheck/agreements.svg'
import identityCheck from '../../assets/clientCheck/identityCheck.svg'
import incomeCheck from '../../assets/clientCheck/incomeCheck.svg'
import messages from '../../i18n'
import money from '../../assets/clientCheck/money.svg'
import paymentCheck from '../../assets/clientCheck/paymentCheck.svg'
import Section from './components/Section/Section'
import spinner from '../../assets/clientCheck/spinner.svg'

interface Props extends IntlInterface, Requirement, WizardInterface {
  getListOfRequirements: any
  push: Function
  showModalDialog: any
}

export class ClientChecks extends React.Component<Props> {
  componentDidMount(): void {
    this.setupChecks()
  }

  setupChecks = () => {
    this.props.getListOfRequirements({
      error: (errorInfo: ApiErrorInfo) => {
        this.props.showModalDialog(API_ERROR({ errorInfo, onRetry: this.setupChecks }))
      },
      deny: () => this.props.push(Routes.KO_ONLINE),
    })
  }

  goToBranch = () => {
    this.props.push(Routes.EXIT)
  }

  continueOnline = () => {
    this.props.push(this.props.nextUrl)
  }

  render() {
    const {
      displayAgreements,
      displayIdentityCheck,
      displayIncomeCheck,
      displayPaymentCheck,
      displayPollingWarning,
      translate,
      translateHTML,
    } = this.props

    return (
      <BForm>
        <BTitle type="h3">{translate(messages.clientChecks.title)}</BTitle>

        {displayPollingWarning && (
          <Notification
            description={translateHTML(messages.clientChecks.fraudCheck.title)}
            iconClass="loader-circle"
            ownIconImg={spinner}
            type="warning"
          />
        )}

        {displayIncomeCheck && (
          <Section img={incomeCheck} msg={messages.clientChecks.incomeCheck} />
        )}
        {displayIdentityCheck && (
          <Section img={identityCheck} msg={messages.clientChecks.identityCheck} />
        )}
        {displayAgreements && <Section img={agreements} msg={messages.clientChecks.agreements} />}
        {displayPaymentCheck && (
          <Section img={paymentCheck} msg={messages.clientChecks.paymentCheck} />
        )}

        <Section img={money} msg={messages.clientChecks.money} />

        <BCardBody dark>
          <BTitle type="h5">
            <BIcon name="info-bubble" theme="mr-2" />
            {translate(messages.clientChecks.note.title)}
          </BTitle>
          {translate(messages.clientChecks.note.perex)}

          <InfoCheckbox className="mt-4" large>
            {translate(messages.clientChecks.note.bullet1)}
          </InfoCheckbox>
          <InfoCheckbox className="mt-2" large>
            {translate(messages.clientChecks.note.bullet2)}
          </InfoCheckbox>
          <InfoCheckbox className="mt-2" large>
            {translate(messages.clientChecks.note.bullet3)}
          </InfoCheckbox>
        </BCardBody>

        <PageControlButtons
          disableSubmit={this.props.displayPollingWarning}
          onSubmit={this.continueOnline}
          secondaryAction={this.goToBranch}
          secondaryMessage={messages.clientChecks.buttons.branch}
          submitMessage={messages.clientChecks.buttons.online}
        />
      </BForm>
    )
  }
}

export default compose(
  wizard,
  intl,
  connect(
    (state: ReduxState) => ({
      ...state.requirement,
    }),
    {
      getListOfRequirements: requirementActions.getListOfRequirements,
      showModalDialog: modalDialogActions.showModalDialog,
      push,
    }
  )
)(ClientChecks)
